import { useCallback } from "react";
import { logOutAndReset } from "@/src/auth/store/logout-thunk";
import { useAppDispatch } from "@/src/common/redux/store";

export function useLogout() {
	const dispatch = useAppDispatch();

	return useCallback(async () => {
		await dispatch(logOutAndReset({ revokeAll: true })).unwrap();
	}, [dispatch]);
}
